import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import ClubTab from "./Club";
import MissionTab from "./Missions";
import Rewards from "./Rewards";
import ClubHistory from "./History";

interface Props {
  tab: number;
  getActiveTab: (tab: number) => void;
}

export default function TabContents({ tab, getActiveTab }: Props) {
  const [activeTab, setActiveTab] = useState(tab);

  useEffect(() => {
    setActiveTab(tab);
  }, [tab]);

  return (
    <Swiper
      style={{
        height: "100%",
        overflowY: "auto",
        paddingTop: "16px",
      }}
      allowTouchMove={false}
      spaceBetween={0}
      slidesPerView={1}
      onSlideChange={(swiper) => getActiveTab(swiper.activeIndex)}
      onSwiper={(swiper) => console.log(swiper, "====")}
    >
      <HandleSweep tab={activeTab} />

      <SwiperSlide>
        <ClubTab />
      </SwiperSlide>
      <SwiperSlide>
        <MissionTab />
      </SwiperSlide>
      <SwiperSlide>
        <Rewards />
      </SwiperSlide>
      <SwiperSlide>
        <MissionTab />
      </SwiperSlide>
      <SwiperSlide>
        <ClubHistory />
      </SwiperSlide>
      <SwiperSlide>
        <MissionTab />
      </SwiperSlide>
    </Swiper>
  );
}
function HandleSweep({ tab }: { tab: number }) {
  const swiper = useSwiper();

  useEffect(() => {
    swiper.slideTo(tab);
  }, [tab]);

  return <></>;
}
